import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
import "./LanguageSelector.scss";


class LanguageSelector extends React.Component {

    constructor(props) {
        super(props);

        if (window.location.pathname.substring(1, 3) == "ar") {
            var body = document.body;
            body.classList.add("site-ar");
        }
        this.state = {
            dropdownOpen: false,
            selectedLang: this.props.currentLanguage,
            defaultLanguage: this.props.currentLanguage
        };
    }




    toggle = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    };

    changeLocale = (data) => {
        console.log(data.fields["Language Code"].value)

        let pathName = window.location.pathname;
        if (pathName.match("^\/[a-z]{2}\/")) {
            pathName = pathName.replace(new RegExp("^\/[a-z]{2}\/"), `/${data.fields["Language Code"].value}/`);
        } else if (window.location.pathname.length <= 3) {
            pathName = "/" + data.fields["Language Code"].value
        } else {
            pathName = "/" + data.fields["Language Code"].value + pathName
        }
        if (data.fields["Language Code"].value == "ar") {
            var body = document.body;

            body.classList.add("site-ar");
        }
        else {
            var body = document.body;

            body.classList.remove("site-ar");
        }
        this.props.history.replace({
            pathname: pathName
        })
        this.setState({ selectedLang: data.fields["Language Title"].value })
      
            window.location.reload()
       
    }

    render() {
        // console.log(this.props, "languageSelectorDatalanguageSelectorData")
        const { languageSelectorData } = this.props;
        //  let defaultLang="";
        //  let currentLang = document.documentElement.lang;
        //     switch (currentLang) {
        //         case "en": currentLang = "English";
        //         defaultLang=currentLang;
        //             break;
        //         case "ar": currentLang = "Arabic";
        //         defaultLang=currentLang;
        //             break;
        //         case "ru": currentLang = "Russian";
        //         defaultLang=currentLang;
        //             break;
        //     }
        return (
            <Dropdown
                isOpen={this.state.dropdownOpen}
                toggle={this.toggle}
                className="jumeirah-language-selector">
                <DropdownToggle>{this.state.selectedLang}</DropdownToggle>
                <DropdownMenu>
                    {languageSelectorData.length > 0 &&
                        languageSelectorData.map((data, index) => {
                            return (
                                <DropdownItem key={index}>
                                    <a style={{ fontSize: "10px" }}
                                        onClick={() => { this.changeLocale(data) }}
                                    >
                                        {data.fields["Language Title"].value}
                                    </a>
                                </DropdownItem>
                            );
                        })}
                </DropdownMenu>
            </Dropdown>
        );
    }
}

export default withRouter(LanguageSelector);

LanguageSelector.propTypes = {
    languageSelectorData: PropTypes.array
};
LanguageSelector.defaultProps = {
    languageSelectorData: []
};
